var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBackBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "12px",
    viewBox: "0 0 22 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Back-BTN") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Course-Areas---Details",
    transform: "translate(-640.000000, -220.000000)",
    fill: "#4B4E6A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(640.000000, 215.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Back-BTN",
    transform: "translate(-0.000400, 4.999750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.161,5.00025 L3.829,5.00025 L7.122,1.70725 C7.512,1.31625 7.512,0.68425 7.122,0.29325 C6.732,-0.09775 6.098,-0.09775 5.708,0.29325 L2.84217094e-14,6.00025 L5.708,11.70725 C5.903,11.90225 6.159,12.00025 6.415,12.00025 C6.671,12.00025 6.927,11.90225 7.122,11.70725 C7.512,11.31625 7.512,10.68425 7.122,10.29325 L3.829,7.00025 L20.161,7.00025 C20.713,7.00025 21.161,6.55225 21.161,6.00025 C21.161,5.44825 20.713,5.00025 20.161,5.00025"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackBtn);
export default __webpack_public_path__ + "static/media/Icon-Back-BTN.fd35837e63c478c803b982eafac4cc79.svg";
export { ForwardRef as ReactComponent };